import GetAllResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import Constants from "../common/Constants";
import { ICaseLawDocument } from "../model/CaseLawDocument";
import CaseLawDocumentMapper from "../service/CaseLawDocumentMapper";
import CaseLawDocumentParamMapper from "../service/CaseLawDocumentParamMapper";

export default class GetAllCaseLawDocumentsInteractor {
  private resource: GetAllResourceEntriesInteractor<ICaseLawDocument>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute() {
    return this.resource.execute(
      Constants.endpointBasePath,
      CaseLawDocumentMapper,
      CaseLawDocumentParamMapper
    );
  }
}
